import { render } from "./IntroductionSection.vue?vue&type=template&id=c15f0a8c"
import script from "./IntroductionSection.vue?vue&type=script&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__